import { ExamineeCountryCode } from '@exam-center/graphql';

/* eslint-disable @cspell/spellchecker */
export const DocumentTypes = [
  'CITIZEN_CARD',
  'DRIVER_LICENSE',
  'PASSPORT',
  'DIGITAL_DOCUMENT',
] as const;
export type DocumentType = (typeof DocumentTypes)[number];

// Middle name is optional, and examinees otherwise type '-' to mean "I don't have one" —
// which the schema rejects. Shared by the domestic and foreigner forms.
export const MIDDLE_NAME_HELPER_TEXT = 'หากไม่มีชื่อกลาง สามารถเว้นว่างได้';

// Shared by the domestic and foreigner registration schemas — the reason field is freer
// than a name: it allows digits, commas and parentheses, but not '.', '\'' or '-'.
export const CAUSE_ALLOW_CHARACTERS = /^[a-zA-Z฀-ฺเ-๎\s,\d()]+$/;
export const CAUSE_ALLOW_CHARACTERS_ERROR_MESSAGE =
  'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9, ช่องว่าง, และเครื่องหมาย , () เท่านั้น';

export const CountryCodeList = [
  { key: ExamineeCountryCode.Af, label: 'Afghanistan (AF)' },
  { key: ExamineeCountryCode.Ax, label: 'Åland Islands (AX)' },
  { key: ExamineeCountryCode.Al, label: 'Albania (AL)' },
  { key: ExamineeCountryCode.Dz, label: 'Algeria (DZ)' },
  { key: ExamineeCountryCode.As, label: 'American Samoa (AS)' },
  { key: ExamineeCountryCode.Ad, label: 'Andorra (AD)' },
  { key: ExamineeCountryCode.Ao, label: 'Angola (AO)' },
  { key: ExamineeCountryCode.Ai, label: 'Anguilla (AI)' },
  { key: ExamineeCountryCode.Aq, label: 'Antarctica (AQ)' },
  { key: ExamineeCountryCode.Ag, label: 'Antigua and Barbuda (AG)' },
  { key: ExamineeCountryCode.Ar, label: 'Argentina (AR)' },
  { key: ExamineeCountryCode.Am, label: 'Armenia (AM)' },
  { key: ExamineeCountryCode.Aw, label: 'Aruba (AW)' },
  { key: ExamineeCountryCode.Au, label: 'Australia (AU)' },
  { key: ExamineeCountryCode.At, label: 'Austria (AT)' },
  { key: ExamineeCountryCode.Az, label: 'Azerbaijan (AZ)' },
  { key: ExamineeCountryCode.Bs, label: 'Bahamas (BS)' },
  { key: ExamineeCountryCode.Bh, label: 'Bahrain (BH)' },
  { key: ExamineeCountryCode.Bd, label: 'Bangladesh (BD)' },
  { key: ExamineeCountryCode.Bb, label: 'Barbados (BB)' },
  { key: ExamineeCountryCode.By, label: 'Belarus (BY)' },
  { key: ExamineeCountryCode.Be, label: 'Belgium (BE)' },
  { key: ExamineeCountryCode.Bz, label: 'Belize (BZ)' },
  { key: ExamineeCountryCode.Bj, label: 'Benin (BJ)' },
  { key: ExamineeCountryCode.Bm, label: 'Bermuda (BM)' },
  { key: ExamineeCountryCode.Bt, label: 'Bhutan (BT)' },
  { key: ExamineeCountryCode.Bo, label: 'Bolivia (BO)' },
  {
    key: ExamineeCountryCode.Bq,
    label: 'Bonaire, Sint Eustatius and Saba (BQ)',
  },
  { key: ExamineeCountryCode.Ba, label: 'Bosnia and Herzegovina (BA)' },
  { key: ExamineeCountryCode.Bw, label: 'Botswana (BW)' },
  { key: ExamineeCountryCode.Bv, label: 'Bouvet Island (BV)' },
  { key: ExamineeCountryCode.Br, label: 'Brazil (BR)' },
  {
    key: ExamineeCountryCode.Io,
    label: 'British Indian Ocean Territory (IO)',
  },
  { key: ExamineeCountryCode.Bn, label: 'Brunei Darussalam (BN)' },
  { key: ExamineeCountryCode.Bg, label: 'Bulgaria (BG)' },
  { key: ExamineeCountryCode.Bf, label: 'Burkina Faso (BF)' },
  { key: ExamineeCountryCode.Bi, label: 'Burundi (BI)' },
  { key: ExamineeCountryCode.Cv, label: 'Cabo Verde (CV)' },
  { key: ExamineeCountryCode.Kh, label: 'Cambodia (KH)' },
  { key: ExamineeCountryCode.Cm, label: 'Cameroon (CM)' },
  { key: ExamineeCountryCode.Ca, label: 'Canada (CA)' },
  { key: ExamineeCountryCode.Ky, label: 'Cayman Islands (KY)' },
  {
    key: ExamineeCountryCode.Cf,
    label: 'Central African Republic (CF)',
  },
  { key: ExamineeCountryCode.Td, label: 'Chad (TD)' },
  { key: ExamineeCountryCode.Cl, label: 'Chile (CL)' },
  { key: ExamineeCountryCode.Cn, label: 'China (CN)' },
  { key: ExamineeCountryCode.Cx, label: 'Christmas Island (CX)' },
  { key: ExamineeCountryCode.Cc, label: 'Cocos Islands (CC)' },
  { key: ExamineeCountryCode.Co, label: 'Colombia (CO)' },
  { key: ExamineeCountryCode.Km, label: 'Comoros (KM)' },
  {
    key: ExamineeCountryCode.Cd,
    label: 'Democratic Republic of the Congo (CD)',
  },
  { key: ExamineeCountryCode.Cg, label: 'Republic of the Congo (CG)' },
  { key: ExamineeCountryCode.Ck, label: 'Cook Islands (CK)' },
  { key: ExamineeCountryCode.Cr, label: 'Costa Rica (CR)' },
  { key: ExamineeCountryCode.Hr, label: 'Croatia (HR)' },
  { key: ExamineeCountryCode.Cu, label: 'Cuba (CU)' },
  { key: ExamineeCountryCode.Cw, label: 'Curaçao (CW)' },
  { key: ExamineeCountryCode.Cy, label: 'Cyprus (CY)' },
  { key: ExamineeCountryCode.Cz, label: 'Czechia (CZ)' },
  { key: ExamineeCountryCode.Ci, label: "Côte d'Ivoire (CI)" },
  { key: ExamineeCountryCode.Dk, label: 'Denmark (DK)' },
  { key: ExamineeCountryCode.Dj, label: 'Djibouti (DJ)' },
  { key: ExamineeCountryCode.Dm, label: 'Dominica (DM)' },
  { key: ExamineeCountryCode.Do, label: 'Dominican Republic (DO)' },
  { key: ExamineeCountryCode.Ec, label: 'Ecuador (EC)' },
  { key: ExamineeCountryCode.Eg, label: 'Egypt (EG)' },
  { key: ExamineeCountryCode.Sv, label: 'El Salvador (SV)' },
  { key: ExamineeCountryCode.Gq, label: 'Equatorial Guinea (GQ)' },
  { key: ExamineeCountryCode.Er, label: 'Eritrea (ER)' },
  { key: ExamineeCountryCode.Ee, label: 'Estonia (EE)' },
  { key: ExamineeCountryCode.Sz, label: 'Eswatini (SZ)' },
  { key: ExamineeCountryCode.Et, label: 'Ethiopia (ET)' },
  { key: ExamineeCountryCode.Fk, label: 'Falkland Islands (FK)' },
  { key: ExamineeCountryCode.Fo, label: 'Faroe Islands (FO)' },
  { key: ExamineeCountryCode.Fj, label: 'Fiji (FJ)' },
  { key: ExamineeCountryCode.Fi, label: 'Finland (FI)' },
  { key: ExamineeCountryCode.Fr, label: 'France (FR)' },
  { key: ExamineeCountryCode.Gf, label: 'French Guiana (GF)' },
  { key: ExamineeCountryCode.Pf, label: 'French Polynesia (PF)' },
  {
    key: ExamineeCountryCode.Tf,
    label: 'French Southern Territories (TF)',
  },
  { key: ExamineeCountryCode.Ga, label: 'Gabon (GA)' },
  { key: ExamineeCountryCode.Gm, label: 'Gambia (GM)' },
  { key: ExamineeCountryCode.Ge, label: 'Georgia (GE)' },
  { key: ExamineeCountryCode.De, label: 'Germany (DE)' },
  { key: ExamineeCountryCode.Gh, label: 'Ghana (GH)' },
  { key: ExamineeCountryCode.Gi, label: 'Gibraltar (GI)' },
  { key: ExamineeCountryCode.Gr, label: 'Greece (GR)' },
  { key: ExamineeCountryCode.Gl, label: 'Greenland (GL)' },
  { key: ExamineeCountryCode.Gd, label: 'Grenada (GD)' },
  { key: ExamineeCountryCode.Gp, label: 'Guadeloupe (GP)' },
  { key: ExamineeCountryCode.Gu, label: 'Guam (GU)' },
  { key: ExamineeCountryCode.Gt, label: 'Guatemala (GT)' },
  { key: ExamineeCountryCode.Gg, label: 'Guernsey (GG)' },
  { key: ExamineeCountryCode.Gn, label: 'Guinea (GN)' },
  { key: ExamineeCountryCode.Gw, label: 'Guinea-Bissau (GW)' },
  { key: ExamineeCountryCode.Gy, label: 'Guyana (GY)' },
  { key: ExamineeCountryCode.Ht, label: 'Haiti (HT)' },
  {
    key: ExamineeCountryCode.Hm,
    label: 'Heard Island and McDonald Islands (HM)',
  },
  { key: ExamineeCountryCode.Va, label: 'Holy See (VA)' },
  { key: ExamineeCountryCode.Hn, label: 'Honduras (HN)' },
  { key: ExamineeCountryCode.Hk, label: 'Hong Kong (HK)' },
  { key: ExamineeCountryCode.Hu, label: 'Hungary (HU)' },
  { key: ExamineeCountryCode.Is, label: 'Iceland (IS)' },
  { key: ExamineeCountryCode.In, label: 'India (IN)' },
  { key: ExamineeCountryCode.Id, label: 'Indonesia (ID)' },
  { key: ExamineeCountryCode.Ir, label: 'Iran (IR)' },
  { key: ExamineeCountryCode.Iq, label: 'Iraq (IQ)' },
  { key: ExamineeCountryCode.Ie, label: 'Ireland (IE)' },
  { key: ExamineeCountryCode.Im, label: 'Isle of Man (IM)' },
  { key: ExamineeCountryCode.Il, label: 'Israel (IL)' },
  { key: ExamineeCountryCode.It, label: 'Italy (IT)' },
  { key: ExamineeCountryCode.Jm, label: 'Jamaica (JM)' },
  { key: ExamineeCountryCode.Jp, label: 'Japan (JP)' },
  { key: ExamineeCountryCode.Je, label: 'Jersey (JE)' },
  { key: ExamineeCountryCode.Jo, label: 'Jordan (JO)' },
  { key: ExamineeCountryCode.Kz, label: 'Kazakhstan (KZ)' },
  { key: ExamineeCountryCode.Ke, label: 'Kenya (KE)' },
  { key: ExamineeCountryCode.Ki, label: 'Kiribati (KI)' },
  { key: ExamineeCountryCode.Kp, label: 'North Korea (KP)' },
  { key: ExamineeCountryCode.Kr, label: 'South Korea (KR)' },
  { key: ExamineeCountryCode.Kw, label: 'Kuwait (KW)' },
  { key: ExamineeCountryCode.Kg, label: 'Kyrgyzstan (KG)' },
  {
    key: ExamineeCountryCode.La,
    label: "Lao People's Democratic Republic (LA)",
  },
  { key: ExamineeCountryCode.Lv, label: 'Latvia (LV)' },
  { key: ExamineeCountryCode.Lb, label: 'Lebanon (LB)' },
  { key: ExamineeCountryCode.Ls, label: 'Lesotho (LS)' },
  { key: ExamineeCountryCode.Lr, label: 'Liberia (LR)' },
  { key: ExamineeCountryCode.Ly, label: 'Libya (LY)' },
  { key: ExamineeCountryCode.Li, label: 'Liechtenstein (LI)' },
  { key: ExamineeCountryCode.Lt, label: 'Lithuania (LT)' },
  { key: ExamineeCountryCode.Lu, label: 'Luxembourg (LU)' },
  { key: ExamineeCountryCode.Mo, label: 'Macao (MO)' },
  { key: ExamineeCountryCode.Mg, label: 'Madagascar (MG)' },
  { key: ExamineeCountryCode.Mw, label: 'Malawi (MW)' },
  { key: ExamineeCountryCode.My, label: 'Malaysia (MY)' },
  { key: ExamineeCountryCode.Mv, label: 'Maldives (MV)' },
  { key: ExamineeCountryCode.Ml, label: 'Mali (ML)' },
  { key: ExamineeCountryCode.Mt, label: 'Malta (MT)' },
  { key: ExamineeCountryCode.Mh, label: 'Marshall Islands (MH)' },
  { key: ExamineeCountryCode.Mq, label: 'Martinique (MQ)' },
  { key: ExamineeCountryCode.Mr, label: 'Mauritania (MR)' },
  { key: ExamineeCountryCode.Mu, label: 'Mauritius (MU)' },
  { key: ExamineeCountryCode.Yt, label: 'Mayotte (YT)' },
  { key: ExamineeCountryCode.Mx, label: 'Mexico (MX)' },
  { key: ExamineeCountryCode.Fm, label: 'Micronesia (FM)' },
  { key: ExamineeCountryCode.Md, label: 'Moldova (MD)' },
  { key: ExamineeCountryCode.Mc, label: 'Monaco (MC)' },
  { key: ExamineeCountryCode.Mn, label: 'Mongolia (MN)' },
  { key: ExamineeCountryCode.Me, label: 'Montenegro (ME)' },
  { key: ExamineeCountryCode.Ms, label: 'Montserrat (MS)' },
  { key: ExamineeCountryCode.Ma, label: 'Morocco (MA)' },
  { key: ExamineeCountryCode.Mz, label: 'Mozambique (MZ)' },
  { key: ExamineeCountryCode.Mm, label: 'Myanmar (MM)' },
  { key: ExamineeCountryCode.Na, label: 'Namibia (NA)' },
  { key: ExamineeCountryCode.Nr, label: 'Nauru (NR)' },
  { key: ExamineeCountryCode.Np, label: 'Nepal (NP)' },
  { key: ExamineeCountryCode.Nl, label: 'Netherlands (NL)' },
  { key: ExamineeCountryCode.Nc, label: 'New Caledonia (NC)' },
  { key: ExamineeCountryCode.Nz, label: 'New Zealand (NZ)' },
  { key: ExamineeCountryCode.Ni, label: 'Nicaragua (NI)' },
  { key: ExamineeCountryCode.Ne, label: 'Niger (NE)' },
  { key: ExamineeCountryCode.Ng, label: 'Nigeria (NG)' },
  { key: ExamineeCountryCode.Nu, label: 'Niue (NU)' },
  { key: ExamineeCountryCode.Nf, label: 'Norfolk Island (NF)' },
  { key: ExamineeCountryCode.Mp, label: 'Northern Mariana Islands (MP)' },
  { key: ExamineeCountryCode.No, label: 'Norway (NO)' },
  { key: ExamineeCountryCode.Om, label: 'Oman (OM)' },
  { key: ExamineeCountryCode.Pk, label: 'Pakistan (PK)' },
  { key: ExamineeCountryCode.Pw, label: 'Palau (PW)' },
  {
    key: ExamineeCountryCode.Ps,
    label: 'Palestine, State of (PS)',
  },
  { key: ExamineeCountryCode.Pa, label: 'Panama (PA)' },
  { key: ExamineeCountryCode.Pg, label: 'Papua New Guinea (PG)' },
  { key: ExamineeCountryCode.Py, label: 'Paraguay (PY)' },
  { key: ExamineeCountryCode.Pe, label: 'Peru (PE)' },
  { key: ExamineeCountryCode.Ph, label: 'Philippines (PH)' },
  { key: ExamineeCountryCode.Pn, label: 'Pitcairn (PN)' },
  { key: ExamineeCountryCode.Pl, label: 'Poland (PL)' },
  { key: ExamineeCountryCode.Pt, label: 'Portugal (PT)' },
  { key: ExamineeCountryCode.Pr, label: 'Puerto Rico (PR)' },
  { key: ExamineeCountryCode.Qa, label: 'Qatar (QA)' },
  {
    key: ExamineeCountryCode.Mk,
    label: 'Republic of North Macedonia (MK)',
  },
  { key: ExamineeCountryCode.Ro, label: 'Romania (RO)' },
  { key: ExamineeCountryCode.Ru, label: 'Russian Federation (RU)' },
  { key: ExamineeCountryCode.Rw, label: 'Rwanda (RW)' },
  { key: ExamineeCountryCode.Re, label: 'Réunion (RE)' },
  { key: ExamineeCountryCode.Bl, label: 'Saint Barthélemy (BL)' },
  {
    key: ExamineeCountryCode.Sh,
    label: 'Saint Helena, Ascension and Tristan da Cunha (SH)',
  },
  {
    key: ExamineeCountryCode.Kn,
    label: 'Saint Kitts and Nevis (KN)',
  },
  { key: ExamineeCountryCode.Lc, label: 'Saint Lucia (LC)' },
  { key: ExamineeCountryCode.Mf, label: 'Saint Martin (MF)' },
  {
    key: ExamineeCountryCode.Pm,
    label: 'Saint Pierre and Miquelon (PM)',
  },
  {
    key: ExamineeCountryCode.Vc,
    label: 'Saint Vincent and the Grenadines (VC)',
  },
  { key: ExamineeCountryCode.Ws, label: 'Samoa (WS)' },
  { key: ExamineeCountryCode.Sm, label: 'San Marino (SM)' },
  {
    key: ExamineeCountryCode.St,
    label: 'Sao Tome and Principe (ST)',
  },
  { key: ExamineeCountryCode.Sa, label: 'Saudi Arabia (SA)' },
  { key: ExamineeCountryCode.Sn, label: 'Senegal (SN)' },
  { key: ExamineeCountryCode.Rs, label: 'Serbia (RS)' },
  { key: ExamineeCountryCode.Sc, label: 'Seychelles (SC)' },
  { key: ExamineeCountryCode.Sl, label: 'Sierra Leone (SL)' },
  { key: ExamineeCountryCode.Sg, label: 'Singapore (SG)' },
  { key: ExamineeCountryCode.Sx, label: 'Sint Maarten (SX)' },
  { key: ExamineeCountryCode.Sk, label: 'Slovakia (SK)' },
  { key: ExamineeCountryCode.Si, label: 'Slovenia (SI)' },
  { key: ExamineeCountryCode.Sb, label: 'Solomon Islands (SB)' },
  { key: ExamineeCountryCode.So, label: 'Somalia (SO)' },
  { key: ExamineeCountryCode.Za, label: 'South Africa (ZA)' },
  {
    key: ExamineeCountryCode.Gs,
    label: 'South Georgia and the South Sandwich Islands (GS)',
  },
  { key: ExamineeCountryCode.Ss, label: 'South Sudan (SS)' },
  { key: ExamineeCountryCode.Es, label: 'Spain (ES)' },
  { key: ExamineeCountryCode.Lk, label: 'Sri Lanka (LK)' },
  { key: ExamineeCountryCode.Sd, label: 'Sudan (SD)' },
  { key: ExamineeCountryCode.Sr, label: 'Suriname (SR)' },
  {
    key: ExamineeCountryCode.Sj,
    label: 'Svalbard and Jan Mayen (SJ)',
  },
  { key: ExamineeCountryCode.Se, label: 'Sweden (SE)' },
  { key: ExamineeCountryCode.Ch, label: 'Switzerland (CH)' },
  {
    key: ExamineeCountryCode.Sy,
    label: 'Syrian Arab Republic (SY)',
  },
  { key: ExamineeCountryCode.Tw, label: 'Taiwan (TW)' },
  { key: ExamineeCountryCode.Tj, label: 'Tajikistan (TJ)' },
  {
    key: ExamineeCountryCode.Tz,
    label: 'Tanzania, United Republic of (TZ)',
  },
  { key: ExamineeCountryCode.Th, label: 'Thailand (TH)' },
  { key: ExamineeCountryCode.Tl, label: 'Timor-Leste (TL)' },
  { key: ExamineeCountryCode.Tg, label: 'Togo (TG)' },
  { key: ExamineeCountryCode.Tk, label: 'Tokelau (TK)' },
  { key: ExamineeCountryCode.To, label: 'Tonga (TO)' },
  {
    key: ExamineeCountryCode.Tt,
    label: 'Trinidad and Tobago (TT)',
  },
  { key: ExamineeCountryCode.Tn, label: 'Tunisia (TN)' },
  { key: ExamineeCountryCode.Tr, label: 'Turkey (TR)' },
  { key: ExamineeCountryCode.Tm, label: 'Turkmenistan (TM)' },
  {
    key: ExamineeCountryCode.Tc,
    label: 'Turks and Caicos Islands (TC)',
  },
  { key: ExamineeCountryCode.Tv, label: 'Tuvalu (TV)' },
  { key: ExamineeCountryCode.Ug, label: 'Uganda (UG)' },
  { key: ExamineeCountryCode.Ua, label: 'Ukraine (UA)' },
  {
    key: ExamineeCountryCode.Ae,
    label: 'United Arab Emirates (AE)',
  },
  {
    key: ExamineeCountryCode.Gb,
    label: 'United Kingdom of Great Britain and Northern Ireland (GB)',
  },
  {
    key: ExamineeCountryCode.Um,
    label: 'United States Minor Outlying Islands (UM)',
  },
  {
    key: ExamineeCountryCode.Us,
    label: 'United States of America (US)',
  },
  { key: ExamineeCountryCode.Uy, label: 'Uruguay (UY)' },
  { key: ExamineeCountryCode.Uz, label: 'Uzbekistan (UZ)' },
  { key: ExamineeCountryCode.Vu, label: 'Vanuatu (VU)' },
  { key: ExamineeCountryCode.Ve, label: 'Venezuela (VE)' },
  { key: ExamineeCountryCode.Vn, label: 'Viet Nam (VN)' },
  {
    key: ExamineeCountryCode.Vg,
    label: 'Virgin Islands British (VG)',
  },
  {
    key: ExamineeCountryCode.Vi,
    label: 'Virgin Islands U.S. (VI)',
  },
  { key: ExamineeCountryCode.Wf, label: 'Wallis and Futuna (WF)' },
  { key: ExamineeCountryCode.Eh, label: 'Western Sahara (EH)' },
  { key: ExamineeCountryCode.Ye, label: 'Yemen (YE)' },
  { key: ExamineeCountryCode.Zm, label: 'Zambia (ZM)' },
  { key: ExamineeCountryCode.Zw, label: 'Zimbabwe (ZW)' },
] as const;

export type CountryCode = (typeof CountryCodeList)[number];

export const CountryCodeLabelMap: ReadonlyMap<CountryCode['key'], CountryCode['label']> = new Map<
  CountryCode['key'],
  CountryCode['label']
>(CountryCodeList.map((country: CountryCode) => [country.key, country.label] as const));

export const DOCUMENT_TYPE_TEXT: Record<DocumentType, string> = {
  CITIZEN_CARD: 'บัตรประชาชน',
  DRIVER_LICENSE: 'ใบขับขี่',
  PASSPORT: 'พาสปอร์ต',
  DIGITAL_DOCUMENT: 'เอกสารราชการรูปแบบดิจิทัล',
};
